'use strict';

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var WS = require('libp2p-websockets');

var WebRTCStar = require('libp2p-webrtc-star');

var WebSocketStar = require('libp2p-websocket-star');

var Multiplex = require('libp2p-mplex');

var SECIO = require('libp2p-secio');

var Bootstrap = require('libp2p-bootstrap');

var libp2p = require('libp2p');

var defaultsDeep = require('@nodeutils/defaults-deep');

var Node =
/*#__PURE__*/
function (_libp2p) {
  _inherits(Node, _libp2p);

  function Node(_options) {
    _classCallCheck(this, Node);

    var wrtcstar = new WebRTCStar({
      id: _options.peerInfo.id
    });
    var wsstar = new WebSocketStar({
      id: _options.peerInfo.id
    });
    var defaults = {
      modules: {
        transport: [WS, wrtcstar, wsstar],
        streamMuxer: [Multiplex],
        connEncryption: [SECIO],
        peerDiscovery: [wrtcstar.discovery, wsstar.discovery, Bootstrap]
      },
      config: {
        peerDiscovery: {
          bootstrap: {
            enabled: true
          },
          webRTCStar: {
            enabled: true
          },
          websocketStar: {
            enabled: true
          }
        },
        EXPERIMENTAL: {
          dht: false,
          pubsub: false
        }
      }
    };
    return _possibleConstructorReturn(this, _getPrototypeOf(Node).call(this, defaultsDeep(_options, defaults)));
  }

  return Node;
}(libp2p);

module.exports = Node;